(function () {
  // Charge les vidéos d'assets seulement quand elles entrent dans le champ.
  // Le marquage ne porte aucune URL exploitable avant passage ici (data-src sur
  // le <source>, data-poster sur la <video>) : tant que l'observateur n'a pas
  // agi, le navigateur n'a rien à télécharger. preload="auto" téléchargeait au
  // contraire le fichier entier au chargement de la page, y compris pour un
  // élément en display:none — c'est le cas des onglets fermés du lookbook et de
  // .lookbook__second, masqué sous 749px.
  //
  // Un élément en display:none n'intersecte jamais : la vidéo d'un onglet fermé
  // ne charge donc qu'à l'ouverture de l'onglet, sans que le JS des onglets ait
  // à s'en occuper.
  if (window.mazarinLazyVideo) return;
  window.mazarinLazyVideo = true;

  var MARGIN = '200px 0px'; // un peu d'avance pour que l'affiche soit déjà là

  function load(video) {
    if (video.dataset.lazyVideoLoaded) return;
    video.dataset.lazyVideoLoaded = '1';

    // L'affiche d'abord : légère, elle peint le cadre pendant que le mp4 arrive.
    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      video.removeAttribute('data-poster');
    }

    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].dataset.src;
      sources[i].removeAttribute('data-src');
    }
    if (!sources.length) return;

    video.load();
    // L'attribut autoplay suffit en principe ; cet appel rattrape les moteurs
    // qui ne relancent pas la lecture après un chargement tardif. Un refus de
    // lecture automatique n'est pas une erreur à remonter.
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        load(entries[i].target);
        observer.unobserve(entries[i].target);
      }
    }, { rootMargin: MARGIN });
  }

  function scan(root) {
    var videos = (root || document).querySelectorAll('video[data-lazy-video]');
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      if (video.dataset.lazyVideoWatched) continue;
      video.dataset.lazyVideoWatched = '1';
      // Sans IntersectionObserver, on retombe sur le comportement d'avant :
      // mieux vaut charger que ne jamais afficher la vidéo.
      if (observer) observer.observe(video);
      else load(video);
    }
  }

  scan();
  // L'éditeur de thème réinjecte le marquage d'une section à chaque réglage.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
